import apiClient from './api';
import type { DonationTier } from '@/types';

export interface CreateDonationDTO {
  amount: number;
  donorInfo: {
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    address?: string;
    municipality: string;
  };
  paymentMethod: 'credit_card' | 'bank_transfer' | 'paypal';
  isRecurring: boolean;
  message?: string;
}

export interface DonationResponse {
  id: string;
  status: 'pending' | 'completed' | 'failed';
  paymentUrl?: string;
}

export const donationService = {
  async getDonationTiers(): Promise<DonationTier[]> {
    return [
      { id: '1', amount: 25, label: 'Supporter', description: 'Join the movement' },
      { id: '2', amount: 50, label: 'Advocate', description: 'Make your voice heard', isPopular: true },
      { id: '3', amount: 100, label: 'Champion', description: 'Lead the change' },
      { id: '4', amount: 250, label: 'Patriot', description: 'Secure our future' },
    ];
  },

  async createDonation(data: CreateDonationDTO): Promise<DonationResponse> {
    const response = await apiClient.post('/donations', data);
    return response.data;
  },

  async verifyPayment(paymentId: string): Promise<{ status: string }> {
    const response = await apiClient.get(`/donations/verify/${paymentId}`);
    return response.data;
  },
};